import { Link } from 'react-router-dom';
import type { ForumTopic } from '@/mocks/forum';
import { getUserById } from '@/mocks/users';

export default function TopicRow({ topic }: { topic: ForumTopic }) {
  const author = getUserById(topic.authorId);
  return (
    <Link
      to={`/forum/topic/${topic.id}`}
      className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
    >
      <img src={author?.avatar} alt={author?.nickname} className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          {topic.hot && (
            <span className="px-2 py-0.5 text-xs rounded-full bg-primary-500 text-background-50 flex-shrink-0">热门</span>
          )}
          <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">{topic.title}</h3>
        </div>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500 flex-wrap">
          <span>{author?.nickname}</span>
          <span>{topic.createdAt}</span>
          <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{topic.replyCount} 回复</span>
          <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{topic.viewCount} 浏览</span>
        </div>
      </div>
      <i className="ri-arrow-right-s-line text-foreground-400 text-xl flex-shrink-0"></i>
    </Link>
  );
}